import Accessibility from "./js/Accessibility";


(() => {
    Accessibility.init();
})()